<template>
  <Label
    :label="translatedQuestion"
    :required="required"
  >
    <slot />
    <div v-if="description" class="setting-question-description">
      {{ $t(`SettingPage.${description}`) }}
    </div>
  </Label>
</template>

<script setup>
import { defineProps, computed } from "vue";
import { useI18n } from "vue-i18n";

const { t, te } = useI18n();

const props = defineProps({
  question: String,
  description: String,
  hasBetaTag: Boolean,
  disabled: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
});

// Same translation fallback the original markup did inline:
// `$te(...) ? $t(...) : question`. Pass the resolved string into Label's
// `label` prop so it renders the standard "{label}(Required)" row.
const translatedQuestion = computed(() => {
  if (!props.question) return "";
  return te(`SettingPage.${props.question}`)
    ? t(`SettingPage.${props.question}`)
    : props.question;
});
</script>

<style scoped></style>

<style src="@/styles/my-practice.css"></style>
